/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Pre_Vetting_DetailInputs */



/**
* | output |
* | --- |
* | "A pre-vetting inspection is run to the same standard as a formal SIRE or RISQ vetting, but before the real thing. We identify observations and compliance gap..." |
*
* @param {Service_Pre_Vetting_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_pre_vetting_detail = /** @type {((inputs?: Service_Pre_Vetting_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Pre_Vetting_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("预审查检查按照与正式 SIRE 或 RISQ 审查相同的标准进行，只是安排在正式审查之前。我们在尚有时间整改时找出观察项和合规差距，使船舶做好充分准备，避免出现可能影响其营运的不利结果。")
	return /** @type {LocalizedString} */ ("A pre-vetting inspection is run to the same standard as a formal SIRE or RISQ vetting, but before the real thing. We identify observations and compliance gaps while there is still time to put them right, so the vessel is well prepared and avoids a negative result that could affect its ability to trade.")
});